import BaseModel from '../base';

interface QuoteDetailBasicInterface {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  country: string;
  businessType: string;
  businessActivity: string;
  policyType: string;
  incomeOrigin: any;
  covers: any;
  declarationQuestions: any;
  projectPeriodStart: string;
  undertakenWork: boolean;
  assigneeId: string;
  providerCode: string;
  elSize: {
    clericalEmployees: number;
    manualEmployees: number;
  };
}

interface CompanyNameInfoInterface {
  companyName: string;
  addressSnippet: string;
  addressLine2: string;
  addressLocality: string;
  addressPostcode: string;
  companyNumber: string;
}

interface CompanyDetailsInfoInterface {
  companyName: string;
  registrationNumber: string;
  taxNumber: string;
  companyIncorporationDate: string;
}

interface BusinessAddressInfoInterface {
  businessCountry: string;
  businessAddress: string;
  city: string;
  detailedAddress: string;
  postcode: string;
}

interface QuoteDetailMsAmlinInterface extends QuoteDetailBasicInterface, CompanyNameInfoInterface {
  employees: number;
  turnoverRaw: number;
}
interface QuoteDetailHiscoxInterface extends QuoteDetailBasicInterface, CompanyDetailsInfoInterface, BusinessAddressInfoInterface {
  turnover: string;
}

interface QuoteDetailChubbInterface extends QuoteDetailBasicInterface, CompanyNameInfoInterface {
  turnover: string;
  technologyIndustry: boolean;
  contract1M: boolean;
}

export class QuoteDetailMsAmlinModel extends BaseModel implements QuoteDetailMsAmlinInterface {
  assigneeId: string;
  employees: number;
  turnoverRaw: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  country: string;
  businessType: string;
  businessActivity: string;
  policyType: string;
  incomeOrigin: any;
  covers: any;
  declarationQuestions: any;
  projectPeriodStart: string;
  undertakenWork: any;
  companyName: string;
  addressSnippet: string;
  addressLine2: string;
  addressLocality: string;
  addressPostcode: string;
  companyNumber: string;
  providerCode: string;
  elSize: {
    clericalEmployees: number;
    manualEmployees: number;
  };
}
export class QuoteDetailHiscoxModel extends BaseModel implements QuoteDetailHiscoxInterface {
  assigneeId: string;
  turnover: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  country: string;
  businessType: string;
  businessActivity: string;
  policyType: string;
  incomeOrigin: any;
  covers: any;
  declarationQuestions: any;
  projectPeriodStart: string;
  undertakenWork: any;
  companyName: string;
  registrationNumber: string;
  taxNumber: string;
  companyIncorporationDate: string;
  businessCountry: string;
  businessAddress: string;
  city: string;
  detailedAddress: string;
  postcode: string;
  providerCode: string;
  elSize: {
    clericalEmployees: number;
    manualEmployees: number;
  };
}
export class QuoteDetailChubbModel extends BaseModel implements QuoteDetailChubbInterface {
  assigneeId: string;
  turnover: string;
  technologyIndustry: boolean;
  contract1M: boolean;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  country: string;
  businessType: string;
  businessActivity: string;
  policyType: string;
  incomeOrigin: any;
  covers: any;
  declarationQuestions: any;
  projectPeriodStart: string;
  undertakenWork: any;
  companyName: string;
  addressSnippet: string;
  addressLine2: string;
  addressLocality: string;
  addressPostcode: string;
  companyNumber: string;
  providerCode: string;
  elSize: {
    clericalEmployees: number;
    manualEmployees: number;
  };
}
